import React, { Component, PropTypes } from 'react';
import { action, autorun, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Modal from '../../Modal';

@inject('stationStore', 'qcRuleStore', 'dataSeriesStore')
@observer
class StationDataSeriesQC extends Component {
  slug;
  dispose;

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  @observable qcRules = [];

  componentWillMount(){
    const { params: { id, dataSeriesId }, stationStore, qcRuleStore } = this.props;
    this.slug = `/station/${id}/data-series`;

    stationStore.fetchDataSeries(id);
    qcRuleStore.fetchItems();

    this.dispose = autorun(() => {
      const station = stationStore.findById(id);
      const dataSeries = station &&
        station.data_series.find(item => +item.id === +dataSeriesId);
      const qcRules = (dataSeries && dataSeries.qc_rules) || [];
      const checkedIds = qcRules.map(qcRule => qcRule.id);
      this.qcRules = qcRuleStore.itemsWithDetails.filter(item => checkedIds.indexOf(item.id) > -1)
    })
  }

  @action onRemoveRule = id => {
    this.qcRules = this.qcRules.filter(item => item.id != id);
  };

  @action onAddRule = e => {
    const {qcRuleStore} = this.props;
    this.qcRules.push(qcRuleStore.itemsWithDetails.filter(item => item.id == e.target.value)[0])
  };

  onSave = () => {
    const {params: { id, dataSeriesId }, dataSeriesStore, stationStore} = this.props;
    const { notify, router } = this.context;
    let qcRuleIds = this.qcRules.map(qcRule => qcRule.id);
    dataSeriesStore.updateQCRules(dataSeriesId, qcRuleIds)
      .then(() => {
        stationStore.fetchDataSeries(id);
        router.push(this.slug);
      })
      .catch(notify.error);
  };

  render() {
    const {params: { id, dataSeriesId },qcRuleStore, stationStore} = this.props;
    let station = stationStore.findById(id);
    let dataSeries = station &&
      station.data_series.find(item => +item.id === +dataSeriesId);
    // const qcRules = (dataSeries && dataSeries.qc_rules) || [];
    let checkedIds = this.qcRules.map(qcRule => qcRule.id);
    // const qcRulesWithDetails = qcRuleStore.itemsWithDetails.filter(item => checkedIds.indexOf(item.id) > -1)
    let selectedRules = qcRuleStore.itemsWithDetails.filter(item => checkedIds.indexOf(item.id) > -1),
      unSelectedRules = qcRuleStore.itemsWithDetails.filter(item => checkedIds.indexOf(item.id) === -1);

    return (
      <Modal title={`QC : ${dataSeries && dataSeries.name}`} slug={this.slug}>
        <div>
          <select value="0" onChange={this.onAddRule} style={{width:'70%'}}>
            <option value="0">Add QC Rule</option>
            {unSelectedRules.sort((a, b) => a.description < b.description ? -1 : 1).map((item, index) => (
              <option key={index} value={item.id}>{item.description}</option>
            ))}
          </select><br/><br/>
          <div className="DataTable" style={{width:'60vh'}}>
            <table>
              <thead>
              <tr>
                <th>id</th>
                <th>Type</th>
                <th>Description</th>
                <th>Details</th>
                <th>{}</th>
              </tr>
              </thead>
              <tbody>{selectedRules.map((item, id) => (<tr key={id}>
                <td>{item.id}</td>
                <td>{item.type_name}</td>
                <td>{item.description}</td>
                <td>{item.typeDetails}</td>
                <td><a onClick={() => this.onRemoveRule(item.id)}>remove</a></td>
              </tr>))}
              </tbody>
            </table>

            <div className="tableActions">
              <button className="button" onClick={this.onSave}>Save</button>
            </div>

          </div>
        </div>
      </Modal>
    );
  }
}

export default StationDataSeriesQC;



// WEBPACK FOOTER //
// ./src/components/Station/DataSeries/StationDataSeriesQC2.js